<div class="comparison-modal">
  <div class="modal-header-compact">
    <div class="title-section">
      <h2>Comparaison d'images</h2>
    </div>

    <div class="controls-section">
      <mat-checkbox color="primary" [(ngModel)]="syncZoom" class="sync-checkbox">
        Zoom synchronisé
      </mat-checkbox>
      <button mat-icon-button (click)="setGlobalZoom(-0.1)" [disabled]="globalZoom <= 0.5" matTooltip="Zoom arrière">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <span class="zoom-indicator">{{ (globalZoom * 100).toFixed(0) }}%</span>
      <button mat-icon-button (click)="setGlobalZoom(0.1)" [disabled]="globalZoom >= 3" matTooltip="Zoom avant">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-icon-button (click)="resetZoom()" matTooltip="Réinitialiser le zoom">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" matTooltip="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="images-grid" [class.grid-2]="images.length === 2" [class.grid-3]="images.length === 3"
    [class.grid-4]="images.length === 4">
    <div *ngFor="let image of images; let i = index" class="image-container">
      <!-- Zooms individuels -->
      <div class="image-controls no-print" *ngIf="!syncZoom">
        <button mat-icon-button (click)="setIndividualZoom(i, -0.1)" [disabled]="individualZooms[i] <= 0.5">
          <mat-icon>zoom_out</mat-icon>
        </button>
        <span class="zoom-indicator">{{ (individualZooms[i] * 100).toFixed(0) }}%</span>
        <button mat-icon-button (click)="setIndividualZoom(i, 0.1)" [disabled]="individualZooms[i] >= 3">
          <mat-icon>zoom_in</mat-icon>
        </button>
      </div>

      <!-- Titre -->
      <div class="image-title">
        <strong>{{ image.title }}</strong>
        <span class="image-date">
          {{ image.createdAt | date:'dd/MM/yyyy HH:mm' }}
        </span>
      </div>

      <!-- Image -->
      <div class="image-wrapper">
        <img [src]="getImageUrl(image)" [alt]="image.title"
          [style.transform]="'scale(' + (syncZoom ? globalZoom : individualZooms[i]) + ')'" class="medical-image">
      </div>
    </div>
  </div>
</div>